<template>
  <div class="doWork" v-loading="load">
    <div class="personal-message">
      <div class="message-left">
        <img height="86px" width="67px" :src="uesrs.examStudent.student.headPic?uesrs.examStudent.student.headPic:'./static/image/defaultImg.png'" alt="用户头像" />
        <div class="personal-name">
          <div class="name">姓 名：{{uesrs.examStudent.student.name}}</div>
          <div class="name">性 别：{{uesrs.examStudent.student.sex==1?"男":'女'}}</div>
          <div class="name">手机号：{{uesrs.examStudent.student.mobile}}</div>
          <!-- <div class="name">证件号码：320400199001015678</div> -->
        </div>
      </div>
      <div class="message-center">
        <!-- <div>会计专业技术资格</div> -->
        <div style="font-size:26px">无纸化考试模拟系统</div>
        <div>
          {{
          newNames}}
        </div>
      </div>
      <div class="message-right">
        <!-- <div class="message-rights">
          <img
            width="31px"
            height="31px"
            style="margin-right:10px;"
            src="../../../static/image/date.png"
            alt
          />
          <div>
            剩余时间：
            {{edTime}}
          </div>
        </div> -->
        <div class="message-submit" @click="submitVisible=true">交 &nbsp;&nbsp;&nbsp; 卷</div>
      </div>
    </div>
    <div class="mian-content">
      <div style="width:23%">
        <div class="right-contents">
          <div class="right-contents-item" v-for="(item,index) in cardList" :key="index">
            <div class="right-contents-item-title">{{item.typeName}}</div>
            <div class="right-contents-item-chengou">
              <div class="chenlaogou">
                <div class="chengou" v-for="(element,inx) in item.numberList" :key="inx" @click="goIndex(element-1)">
                  <div style="color: #4C92EB;">{{element}}</div>
                  <div>
                    <span style="color: #ff000c;" v-if="questionList[element-1].check">?</span>
                    <span style="color: #ff000c;" v-else-if="questionList[element-1].collects">?</span>
                    <span v-else-if="questionList[element-1].userAnswer==''||questionList[element-1].userAnswer==[]||questionList[element-1].userAnswer==null">*</span>
                    <span v-else>&nbsp;</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-titles">
          <div>说明:1.题号下方的*符号代表该小题尚未作答</div>
          <div>2.题号下方的?符号代表该小题做过标记！</div>
          <div>3.选择选项的同时自动保存答案！</div>
        </div>
        <div class="right-buttons" @click="counterDialogVisible=true">
          <img src="../../../static/image/jsq.png" alt />
          <div>计算器</div>
        </div>
      </div>
      <div style="border: solid 1px rgba(176, 190, 213, 1);width:77%;background: rgba(221, 235, 246, 1);
      ">
        <div class="question-title">试题</div>

        <div class="question" style="padding-bottom:60px" v-if="questionList[nowIndex]">
          <div class="question-name">
            <div class="name">{{nowIndex+1}} 、{{questionList[nowIndex].questionTypeName}}</div>
            <div>
              <div v-html="questionList[nowIndex].ptitle"></div>
              <div v-html="questionList[nowIndex].title"></div>
            </div>
          </div>
          <div class="question-answer" v-if="questionList[nowIndex].mode=='多选'">
            <el-checkbox-group v-model="questionList[nowIndex].userAnswer" @change="preserverData()">
              <el-checkbox v-for="(element,inx) in questionList[nowIndex].optionList" :key="inx" :label="element.options">
                <span style="color: #323232;font-weight: 700;">{{element.options}}.</span>
                <span v-html="element.name" style="white-space: normal;line-height: 20px !important;font-size:13px;color:#333"></span>
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <div class="question-answer" v-if="questionList[nowIndex].mode=='判断'">
            <el-radio-group v-model="questionList[nowIndex].userAnswer" @change="preserverData()">
              <el-radio label="对">
                <span style="white-space: normal;line-height: 20px !important;">对</span>
              </el-radio>
              <el-radio label="错">
                <span style="white-space: normal;line-height: 20px !important;">错</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="question-answer" v-if="questionList[nowIndex].mode=='单选'">
            <el-radio-group v-model="questionList[nowIndex].userAnswer" :max="1" @change="preserverData()">
              <el-radio v-for="(element,inx) in questionList[nowIndex].optionList" :key="inx" :label="element.options">
                <span style="color: #323232;font-weight: 700;">{{element.options}}.</span>
                <span v-html="element.name" style="white-space: normal;line-height: 20px !important;font-size:13px;color:#333"></span>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="question-answer" v-if="questionList[nowIndex].mode=='填写'&&ueShow">
            <ue :id="'id'+nowIndex" :ids="nowIndex" :value="questionList[nowIndex].userAnswer" @setName="setNameText"></ue>
          </div>
        </div>
        <div class="tab-button">
          <div class="flex-item">
            <!-- <input style="" type="checkbox" />标记 -->
            <!-- @click="collectQuestion(item,index)" -->
            <el-checkbox @change="collectQuestion" v-model="questionList[nowIndex].collects">标记</el-checkbox>
          </div>
          <div class="flex-item" @click="goIndex(nowIndex-1)">
            <!-- <span></span> -->
            <button :disabled="nowIndex==0?true:false">上一题</button>
          </div>

          <div class="flex-item" @click="goIndex(nowIndex+1)">
            <button :disabled="nowIndex==questionList.length-1?true:false">下一题</button>
          </div>
        </div>
      </div>
    </div>
    <drag @closeDialog="closeDialogEvement()" v-if="counterDialogVisible"></drag>
    <el-dialog title="您正在结束作答" center :visible.sync="submitVisible" width="30%" :close-on-click-modal="false">
      <div :style="`color: #455A64;padding:20px;`">{{questionList.length-doNumsDone?"您还有"+(questionList.length-doNumsDone)+'道试题未作答，':''}} 是否确定提交作答？</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="submitVisible = false">取 消</el-button>
        <el-button size="small" style="background:#c7000a;color:#fff;border-color:#c7000a;" @click="submitExercise">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="您已成功交卷" center :visible.sync="scoreVisible" width="30%" :close-on-click-modal="false">
      <div :style="`color: #455A64;padding:20px;`">
        您的分数为
        <span :class="score>60?'scoreColor1':'scoreColor'">{{score}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" style="background:#c7000a;color:#fff;border-color:#c7000a;" @click="submitScore">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import drag from "../common/drag";
import ue from "../common/UE2";
import elDragDialog from "../directive/el-drag-dialog";
export default {
  components: { ue, drag },
  directives: { elDragDialog },
  data () {
    return {
      ueShow: true,
      uesrs: {
        examStudent: {
          student: {}
        }
      },
      edTime: null,
      nowTime: null,
      questionList: [{ check: false, collects: false }],
      norNumberList: [],
      correctNumberList: [],
      cardList: [],
      timerModel: "",
      nowIndex: 0,
      doNumsDone: 0,
      timer: {
        hour: 0,
        minute: 0,
        second: 60
      },
      score: 0,
      showResult: false,
      load: false,
      submitVisible: false,
      scoreVisible: false,
      counterDialogVisible: false
    };
  },
  created () {
    // this.getNowTime();
  },
  methods: {
    getNowTime () {
      this.api.examStudent.getCurrentDateTime().then(res => {
        if (res.code == 0) {
          this.nowTime = res.currentDateTime;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    collectQuestion () {
      // this.api.question
      //   .collectQuestion({
      //     typeId: this.$route.query.examId,
      //     type: "exam",
      //     questionId: this.questionList[this.nowIndex].id
      //   })
      //   .then(res => {
      //     if (res.code == 0) {
      //       // this.$message.success(res.msg);
      //       // this.questionList[this.nowIndex].collect = !this.questionList[
      //       //   this.nowIndex
      //       // ].collect;
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
    },

    preserverData () {
      // localStorage.setItem("questionList",JSON.stringify(this.questionList))
      sessionStorage.setItem("questionList", JSON.stringify(this.questionList));
    },

    getLocalQuestionList () {
      this.questionList = JSON.parse(sessionStorage.getItem("questionList"));
      // console.log("this.questionList",this.questionList)
    },

    submitExercise () {
      let questionFormList = [];
      let array = JSON.parse(JSON.stringify(this.questionList));
      array.forEach(item => {
        if (item.mode == "多选") {
          let userAnswer = "";
          if (item.userAnswer.length > 0) {
            item.userAnswer.sort((a, b) => {
              return a.localeCompare(b);
            });
            item.userAnswer.forEach((itemss, inx) => {
              userAnswer =
                userAnswer +
                itemss +
                (item.userAnswer.length - 1 == inx ? "" : ",");
            });
          }
          item.userAnswer = userAnswer;
        } else {
        }
        questionFormList.push({
          id: item.id,
          userAnswer: item.userAnswer
        });
        // console.log("1111",questionFormList)
      });
      // let exerciseTime =
      //   this.$route.query.dotime - (this.timer.hour * 60 + this.timer.minute);
      this.api.question
        .simulateSubmitExerciseForModelExam({
          typeId: this.$route.query.examId,
          examSettingId: this.$route.query.id,
          type: "modelExam",
          questionFormList: questionFormList
        })
        // .submitExercise({
        //   typeId: this.$route.query.examId,
        //   examSettingId: this.$route.query.id,
        //   type: "exam",
        //   questionFormList: questionFormList,
        //   exerciseTime: exerciseTime
        // })
        .then(res => {
          this.load = true;
          // this.$message.success("正在提交考卷，请稍后！")
          this.submitVisible = false;
          if (res.code == 0) {
            this.score = res.score;
            sessionStorage.removeItem("questionList");
            this.$router.push({
              path: "/searchExam",
              query: { examSettingId: this.$route.query.id, exerciseId: res.exerciseId }
            });
            this.$message.success("提交成功");
            // this.$message.success("提交成功,您的分数为" + this.score + "分");
            this.load = true;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    submitScore () { },
    // setTimes() {
    //   this.timerModel = setInterval(this.timerEvent, 1000);
    // },
    setTimes () {
      // this.timerModel = setInterval(this.timerEvent, 1000);
      this.getNowTime();
      // this.$set(
      //   this,
      //   "edTime",
      //   this.examCountDownFun(this.nowTime,
      //     new Date(this.uesrs.examEndTime.replace(/-/g, "/")).getTime()
      //   )
      // );
      // this.temp = setInterval(() => {
      //   // 1-进入考场 2-立即报名 3-成绩查询 4-等待报名  5-报名结束 6-考试结束
      //   this.$set(this, "nowTime", this.nowTimeCountDownFun(this.nowTime));
      //   this.$set(
      //     this,
      //     "edTime",
      //     this.examCountDownFun(
      //       this.nowTime,
      //       new Date(this.uesrs.examEndTime.replace(/-/g, "/")).getTime()
      //     )
      //   );
      //   if (!this.edTime) {
      //     this.submitExercise();
      //   }
      // }, 1000);
    },
    timerEvent () {
      if (
        this.timer.second == 0 &&
        this.timer.minute == 0 &&
        this.timer.hour == 0
      ) {
        // clearInterval(this.timerModel);
        this.submitExercise();
      } else {
        if (this.timer.second == 0) {
          if (this.timer.minute == 0) {
            if (this.timer.hour > 0) {
              this.timer.minute = 60;
              this.timer.hour = this.timer.hour - 1;
            }
          }
          if (this.timer.minute > 0) {
            this.timer.second = 60;
            this.timer.minute = this.timer.minute - 1;
          }
        }
        this.timer.second--;
      }
    },
    setNameText (val) {
      // console.log("1111", val);
      if (val.index >= 0) {
        this.questionList[val.index].userAnswer = val.content;
        this.preserverData();
      }
    },
    closeDialogEvement () {
      this.counterDialogVisible = false;
    },
    simulateGetQuestionByModelExam () {
      this.load = true;
      let params = { examId: this.$route.query.examId, type: "exam" };
      // this.api.question
      //   .saveModelExamTime({
      //     examId: this.$route.query.examId,
      //     examSettingId: this.$route.query.id
      //   })
      //   .then(res => {});
      this.api.question
        .simulateGetQuestionByModelExam({
          examId: this.$route.query.examId,
          examSettingId: this.$route.query.id
        })
        .then(res => {
          // this.setTimes();
          this.load = false;
          if (res.code == 0) {
            res.data.forEach(element => {
              element.collects = false;
              element.check = false;
              if (element.mode == "多选") {
                element.userAnswer = [];
              } else {
                element.userAnswer = "";
              }
            });
            if (sessionStorage.getItem("questionList")) {
              this.getLocalQuestionList();
            } else {
              this.questionList = res.data;
            }
            this.cardList = res.cardList;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    goIndex (index) {
      this.ueShow = false;
      // console.log("index", this.questionList[index - 1].userAnswer);
      this.$nextTick(function () {
        this.nowIndex = index;
        this.ueShow = true;
      });
    },
    // getExamSettingInfo() {
    //   this.api.examSetting
    //     .getExamSettingInfo({
    //       examSettingId: this.$route.query.id
    //     })
    //     .then(res => {
    //       if (res.code == 0) {
    //         this.uesrs = res.data;
    //         this.getQuestionByChapter();
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     });
    // }
  },
  destroyed () {
    clearInterval(this.temp);
  },
  watch: {
    submitVisible (val, oldVal) {
      if (val) {
        this.doNumsDone = 0;
        this.questionList.forEach(item => {
          if (item.mode == "多选") {
            if (item.userAnswer.length > 0) {
              this.doNumsDone++;
            }
          } else {
            if (item.userAnswer) {
              this.doNumsDone++;
            }
          }
        });
      }
    }
  },
  computed: {
    newNames () {
      return localStorage.getItem("newNames");
    }
  },
  mounted () {
    // if (this.$route.query.dotime) {
    //   this.timer.hour = Math.floor(this.$route.query.dotime / 60) || 0;
    //   if (this.$route.query.dotime % 60 == 0) {
    //     this.timer.hour = this.timer.hour - 1;
    //     this.timer.minute = 59;
    //   } else {
    //     this.timer.minute = (this.$route.query.dotime % 60) - 1;
    //   }
    //   this.timer.second = 60;
    // }
    this.simulateGetQuestionByModelExam();
  }
};
</script>
<style scoped>
.scoreColor {
  color: #f55;
  font-weight: 600;
}
.scoreColor1 {
  color: #24d2b5;
  font-weight: 600;
}
</style>
<style lang="less" rel="stylesheet/less">
@import "../../../static/css/main.less";
.doWork {
  .el-radio + .el-radio {
    margin-left: 0px !important;
  }
  display: flex;
  width: 1200px;
  margin: auto;
  height: 100%;
  background-color: rgb(246, 249, 250);
  flex-direction: column;
  .mian-content {
    display: flex;
    margin-top: 10px;
    position: relative;
    .tab-button {
      padding: 10px;
      margin-left: 30px;
      position: absolute;
      bottom: 0px;
      display: flex;
      .flex-item {
        margin-right: 20px;
        label {
          display: block !important;
          margin-top: -4px !important;
          margin-bottom: 10px !important;
          display: flex !important;
          align-items: flex-start !important;
          justify-content: flex-start !important;
          .el-radio__input.is-checked .el-radio__inner {
            border-color: rgb(160, 170, 188) !important;
            background: rgb(160, 170, 188) !important;
          }
          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: rgb(69, 90, 100) !important;
          }
          .el-checkbox__inner {
            width: 12px !important;
            height: 12px !important;
            border: 1px solid #333 !important;
          }
          .el-checkbox__inner::after {
            height: 8px !important;
            left: 3px !important;
            top: 0px !important;
            border: 1px solid #333 !important;
            border-left: 0 !important;
            border-top: 0 !important;
            //   transform: rotate(45deg) scaleY(1) !important;
          }
          .el-checkbox__input {
            margin-top: 4px !important;
            line-height: 30px !important;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            border-color: #333 !important;
            background: #ffffff !important;
          }
          .el-checkbox__input.is-checked .el-checkbox__inner {
            &:hover {
              border-color: rgb(160, 170, 188) !important;
            }
          }
          .el-checkbox__label {
            font-size: 13px !important;
            line-height: 35px !important;
            color: #333 !important;
          }
        }
      }
    }
    .question {
      border-top: solid 2px rgba(49, 118, 173, 1);
      padding: 0 10px;
      .question-answer {
        // margin-left: 30px;
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        p {
          display: inline;
        }
        .el-checkbox-group {
          width: 100% !important;

          .el-checkbox {
            margin-right: 30px !important;
            line-height: 30px !important;

            padding: 0 10px;
            // &:hover {
            //   background: rgb(246, 249, 250);
            // }
          }
          label {
            display: block !important;
            // height: 40px !important;
            margin-bottom: 10px !important;
            display: flex !important;
            align-items: flex-start !important;
            justify-content: flex-start !important;
            .el-radio__input.is-checked .el-radio__inner {
              border-color: rgb(160, 170, 188) !important;
              background: rgb(160, 170, 188) !important;
            }
            .el-checkbox__input.is-checked + .el-checkbox__label {
              color: rgb(69, 90, 100) !important;
            }
            .el-checkbox__inner {
              width: 12px !important;
              height: 12px !important;
              border: 1px solid #333 !important;
            }
            .el-checkbox__inner::after {
              height: 8px !important;
              left: 3px !important;
              top: 0px !important;
              border: 1px solid #333 !important;
              border-left: 0 !important;
              border-top: 0 !important;
              //   transform: rotate(45deg) scaleY(1) !important;
            }
            .el-checkbox__input {
              margin-top: 4px !important;
              line-height: 30px !important;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner {
              border-color: #333 !important;
              background: #ffffff !important;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner {
              &:hover {
                border-color: rgb(160, 170, 188) !important;
              }
            }
            .el-checkbox__label {
              font-size: 16px !important;
              line-height: 35px !important;
              color: rgb(69, 90, 100) !important;
            }
          }
        }
        .el-radio-group {
          width: 100% !important;
          .el-radio {
            margin-right: 30px !important;
            padding: 0 10px;
            display: flex !important;
            align-items: flex-start !important;
            // &:hover {
            //   background: rgb(246, 249, 250);
            // }
          }

          .el-radio__input {
            line-height: 32px !important;
          }
          label {
            display: block !important;
            line-height: 30px !important;
            margin-bottom: 10px !important;
            .el-radio__input.is-checked .el-radio__inner {
              border-color: rgb(121, 121, 121) !important;
              background: #fff !important;
            }
            .el-radio__inner {
              width: 12px !important;
              height: 12px !important;
              border-color: rgb(121, 121, 121) !important;
            }
            .el-radio__inner::after {
              width: 6px !important;
              background: rgb(121, 121, 121) !important;
              height: 6px !important;
            }
            .el-radio__label {
              font-size: 16px !important;
              color: rgb(69, 90, 100) !important;
            }
          }
        }
      }
      .question-name {
        line-height: 24px;
        text-align: left;
        p {
          display: inline;
        }
        font-size: 13px;

        .name {
          font-family: "微软雅黑 Bold", "微软雅黑";
          font-weight: 700;
          font-style: normal;
          color: #323232;
          font-size: 13px;
          border-bottom: solid 1px rgba(176, 190, 213, 1);
        }
      }
    }
    .question-title {
      width: 132px;
      .center();
      height: 32px;
      border: solid 1px rgba(49, 118, 173, 1);
      background: rgba(71, 144, 197, 1);
      border-radius: 10px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
      box-sizing: border-box;
      box-shadow: none;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 400;
      font-style: normal;
      color: #323232;
      line-height: 13px;
    }
    .right-buttons {
      .center();
      padding: 1px;
      background-color: rgb(222, 222, 222);
      width: 99px;
      height: 36px;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #323232;
      line-height: 14px;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(185, 185, 185, 1);
      border-radius: 4px;
      justify-content: flex-start;
      cursor: pointer;
      img {
        width: 32px;
        height: 32px;
      }
      div {
        margin-left: 10px;
      }
    }
    .right-titles {
      div {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #ff000c;
        line-height: 24px;
      }
    }
    .right-contents {
      .right-contents-item {
        .right-contents-item-chengou {
          background-color: rgba(222, 241, 248, 1);
          border: solid 1px rgba(175, 197, 247, 1);
          padding: 6px;

          .chenlaogou {
            border-top: solid 1px rgba(176, 190, 213, 1);
            border-left: solid 1px rgba(176, 190, 213, 1);
            display: inline-block;
            flex-wrap: wrap;

            .chengou {
              height: 34px;
              width: 21px;
              padding: 2px;
              text-align: center;
              display: inline-block;
              cursor: pointer;
              flex-direction: column;

              border-bottom: solid 1px rgba(176, 190, 213, 1);
              border-right: solid 1px rgba(176, 190, 213, 1);
            }
          }
          margin-bottom: 10px;
        }
        .right-contents-item-title {
          width: 100%;
          .center();
          height: 32px;
          border: solid 1px rgba(49, 118, 173, 1);
          background: rgba(71, 144, 197, 1);
          border-radius: 10px;
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          box-sizing: border-box;
          box-shadow: none;
          font-family: "微软雅黑 Bold", "微软雅黑";
          font-weight: 400;
          font-style: normal;
          color: #323232;
          line-height: 13px;
        }
      }
    }
  }
  .personal-message {
    padding: 0 40px 0 10px;
    .center();
    background: linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    background: -webkit-linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    background: -o-linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    background: -moz-linear-gradient(
      180deg,
      rgba(121, 186, 252, 1) 0%,
      rgba(111, 176, 233, 1) 100%
    );
    justify-content: space-between;
    .message-center {
      .center();
      flex-direction: column;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
    }
    .message-left {
      padding: 20px 0;
      .center();
      .personal-name {
        margin-left: 10px;
        height: 76px;
        .center();
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        .name {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 16px;
          color: #fff;
          line-height: 16px;
        }
      }
    }
    .message-right {
      padding: 20px 0;

      .message-submit {
        cursor: pointer;
        .center();
        float: right;
        margin-top: 14px;
        width: 82px;
        height: 28px;
        background: linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        background: -webkit-linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        background: -o-linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        background: -moz-linear-gradient(
          180deg,
          rgba(243, 229, 168, 1) 0%,
          rgba(248, 213, 88, 1) 50%,
          rgba(237, 151, 28, 1) 100%
        );
        border: 1px solid rgba(218, 151, 47, 1);
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #323232;
        line-height: 12px;
      }
      .message-rights {
        width: 252px;
        .center();
        height: 46px;
        background: linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        background: -webkit-linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        background: -o-linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        background: -moz-linear-gradient(
          180deg,
          rgba(255, 250, 230, 1) 0%,
          rgba(232, 210, 47, 1) 100%
        );
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #ff000c;
        font-size: 20px;
        border-radius: 6px;
        font-weight: bold;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/doWork.vue